<template>
  <router-view></router-view>
</template>

<script setup>

</script>
<style>
input, select, textarea {
  border: 1px solid #bebaba87 !important;
}
.attachment-icon-b{
  font-size: 14px;
  cursor: pointer;
}
.cursor-pointer{
cursor: pointer;
}
</style>